import { Snackbar } from "@material-ui/core";

import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import SocieteService from "../services/Societe";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ConfigurerSeuilClient = ({
  setOnConfigSeuil,
  clientName,
  idSociete,
  seuilClientvalue,
}) => {
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [seuilValue, setSeuilValue] = useState(null);
  const [desc, setDesc] = useState();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeSeuilValue = (event) => {
    setSeuilValue(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnConfigSeuil(false);
  };

  const onAddSocieteSeuil = () => {
    if (seuilValue == null || seuilValue === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du seuil est vide ! ");
    } else {
      let societeSeuilModel = {
        idSociete: idSociete,
        idUser: getCurrentUserId(),
        seuil: seuilValue,
      };
      SocieteService.addSocieteSeuil(societeSeuilModel)
        .then((response) => {
          if (response?.data?.success) {
            setOpenAlert(true);
            setTimeout(setOnConfigSeuil(false), 5000);
            setOnConfigSeuil(false);
            setOpen(false);
            window.location.reload(false);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText(response?.data?.error);
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  };

  return (
    <>
      <div class="modal fade" id="configurer-seuil-client">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">
                Configurer seuil Client : <b>{clientName}</b>
              </h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Seuil</label>
                    <input
                      placeholder="Seuil"
                      onChange={onChangeSeuilValue}
                      type="number"
                      id="inputName"
                      className="form-control"
                      value={seuilValue != null ? seuilValue : seuilClientvalue}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={onAddSocieteSeuil}
                class="btn btn-light"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <Snackbar
          open={openAlert}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleClose} severity="success">
            Ajout avec success !
          </Alert>
        </Snackbar>
      )}

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConfigurerSeuilClient;
